const OPTIMIZELY_SCRIPT_URL = "https://optimizely.teliacompany.com/cdn/js/28415250160.js";

const init = (scriptSrcUrl) => {
  const body = document.getElementsByTagName("body")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.setAttribute("defer", "defer");
  script.src = scriptSrcUrl;
  body.appendChild(script);
};
const inject = () => {
  init(OPTIMIZELY_SCRIPT_URL);
};

export { inject };
//# sourceMappingURL=b2x-optimizely.esm.js.map
